import React, { useEffect } from 'react';
import Scrolltop from '../components/Scrolltop';
import "./privacypolicy.css";
import { Footer } from '../components/footer';

import { Upperbox } from '../components/Upperbox';

import Nav from "../components/Nav";

const Privacypolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='page-background'>
      <Upperbox />
      <Nav />
     

    

      {/* Privacy Policy Section */}
      <div className='privacy-container'>
        <h2 className='section-title' data-aos="fade-down">Privacy Policy</h2>
        <p>
          At <strong>Sri Krishnaa Authentic Indian Cuisine</strong>, we are committed to protecting your privacy and ensuring the security of your personal information. 
          This Privacy Policy explains how we collect, use, and safeguard your data when you interact with us through <a href="http://www.srikrishnaaindiancuisine.co.uk">www.srikrishnaaindiancuisine.co.uk</a>.
          Our practices comply with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
        </p>

        <h3>Who We Are</h3>
        <p>
          Sri Krishnaa Authentic Indian Cuisine specializes in online delivery, takeaway, and catering services in Liverpool, UK. Our website serves as a hub for
          exploring our menu, placing orders, and connecting with us.
        </p>

        <h3>What Information We Collect</h3>
        <ul>
          <li><strong>Contact Information:</strong> Name, email address, phone number, and delivery address.</li>
          <li><strong>Order and Payment Details:</strong> Items ordered, payment methods, billing information, and transaction history.</li>
          <li><strong>Technical and Usage Data:</strong> IP address, browser type, operating system, and website interaction data.</li>
        </ul>

        <h3>How We Use Your Information</h3>
        <ul>
          <li>Ensure accurate and timely delivery of orders.</li>
          <li>Address inquiries and feedback for better customer support.</li>
          <li>Analyze preferences to enhance offerings and website performance.</li>
          <li>Send tailored promotional updates (if opted in).</li>
          <li>Meet regulatory and legal obligations.</li>
        </ul>

        <h3>Sharing Your Information</h3>
        <p>
          We do not sell or rent your personal information to third parties. However, we may share data with:
        </p>
        <ul>
          <li><strong>Payment Processors:</strong> To facilitate secure transactions.</li>
          <li><strong>Delivery Partners:</strong> To ensure accurate delivery of orders.</li>
          <li><strong>IT Service Providers:</strong> To maintain and secure our website.</li>
        </ul>

        <h3>Your Rights</h3>
        <ul>
          <li>Access, update, or delete your personal data where legally permissible.</li>
          <li>Restrict or object to data processing for certain purposes.</li>
          <li>Unsubscribe from promotional communications.</li>
        </ul>
        <p>
          To exercise these rights, contact us at <a href="mailto:info@srikrishnaaindiancuisine.co.uk">info@srikrishnaaindiancuisine.co.uk</a>.
        </p>

        <h3>How We Protect Your Data</h3>
        <p>
          Robust security measures, including encryption and regular monitoring, are implemented to safeguard your data. 
          While we strive for the highest standards, no online system is completely immune to breaches.
        </p>

        <h3>Policy Updates</h3>
        <p>
          This Privacy Policy is subject to periodic revisions. Changes will be posted on our website, and significant updates may be communicated directly to you.
        </p>

        <h3>Contact Us</h3>
        <p>Email: <a href="mailto:info@srikrishnaaindiancuisine.co.uk">info@srikrishnaaindiancuisine.co.uk</a></p>
        <p>Phone: +44 7554466904</p>
      </div>

      {/* Additional Components */}
    
      <Scrolltop />
    
      <Footer />
    </div>
  );
};

export default Privacypolicy;
